// shadcn/ui skeleton (CLI 4.21.0), rebound to docs/tokens.css. Upstream
// pulses; DESIGN.md allows no endless animation, so ours stands still.
import * as React from "react";
import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("rounded-control bg-fill-secondary", className)}
      {...props}
    />
  );
}

export { Skeleton };
